import { useMemo } from 'react'

import { useLocalStorage } from './useLocalStorage'

type StorageType = {
  shouldTranslateTexts: boolean
  shouldTranslateEnums: boolean
}

export const useLocalStorageShouldTranslate = () => {
  const [value, setValue] = useLocalStorage<StorageType>(
    'shouldTranslateOptions',
  )

  const memoizedValue: StorageType = useMemo(
    () => ({
      shouldTranslateEnums:
        value?.shouldTranslateEnums === undefined
          ? true
          : value.shouldTranslateEnums,
      shouldTranslateTexts:
        value?.shouldTranslateTexts === undefined
          ? true
          : value.shouldTranslateTexts,
    }),
    [value],
  )

  return {
    shouldTranslateTexts: memoizedValue.shouldTranslateTexts,
    shouldTranslateEnums: memoizedValue.shouldTranslateEnums,
    onChangeShouldTranslateTexts: () => {
      setValue({
        shouldTranslateTexts: !memoizedValue.shouldTranslateTexts,
        shouldTranslateEnums: memoizedValue.shouldTranslateEnums,
      })
    },
    onChangeShouldTranslateEnums: () => {
      setValue({
        shouldTranslateTexts: memoizedValue.shouldTranslateTexts,
        shouldTranslateEnums: !memoizedValue.shouldTranslateEnums,
      })
    },
  }
}
